import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

interface IFillerAudioFileList {
  text: string;
  value: string;
}

interface TreeNodeState {
  disabled: boolean;
  selected: boolean;
  opened: boolean;
}

interface TreeNodeLiAttr {
  isCascadeEnabled: boolean;
}

interface TreeNode {
  id: string;
  text: string;
  parent: string;
  isGroup: boolean;
  type: string;
  searchGroupTypeCode: string;
  a_attr: string;
  isSelected: boolean;
  state: TreeNodeState;
  li_attr: TreeNodeLiAttr;
  saveSearchSecurityGroupId: number;
  documentCount: number;
  textWithoutCount: string;
}

interface IMP3DataComponentState {
  produceLoadFile: boolean;
  redactionType: number;
  isBurnRedactionSelected: boolean;
  isRedactionByAnnotation: boolean;
  specifiedRedactionTagList: string | null;
  fillerAudioID: string | null;
  fillerAudioList: any[] | null;
}

interface IProductionState {
  securityGroupId: number;
  editModeProductionId: number;
  productionSetId: number;
  fillerAudioFileList: IFillerAudioFileList[];
  mP3DataComponentState: IMP3DataComponentState;
  redactionTagList: TreeNode[];
  isFieldsChanged?: boolean;
}

const initialState: IProductionState = {
  securityGroupId: 0,
  productionSetId: 0,
  editModeProductionId: 99999,
  fillerAudioFileList: [],
  mP3DataComponentState: {
    produceLoadFile: false,
    redactionType: 0,
    isBurnRedactionSelected: false,
    isRedactionByAnnotation: false,
    specifiedRedactionTagList: '',
    fillerAudioID: null,
    fillerAudioList: null,
  },
  redactionTagList: [],
  isFieldsChanged: false,
};

const productionSlice = createSlice({
  name: 'production',
  initialState,
  reducers: {
    setProduction: (
      state,
      action: PayloadAction<{
        securityGroupId: number;
        productionSetId: number;
      }>
    ) => {
      state.securityGroupId = action.payload.securityGroupId;
      state.productionSetId = action.payload.productionSetId;
    },
    clearProduction: (state) => {
      state.securityGroupId = 0;
      state.productionSetId = 0;
    },

    setSecurityGroupId: (state, action: PayloadAction<number>) => {
      state.securityGroupId = action.payload;
    },
    clearSecurityGroupId: (state) => {
      state.securityGroupId = 0;
    },

    setProductionSetSetId: (state, action: PayloadAction<number>) => {
      state.productionSetId = action.payload;
    },
    clearProductionSetId: (state) => {
      state.productionSetId = 0;
    },

    setFillerAudioFileList: (
      state,
      action: {payload: IFillerAudioFileList[]}
    ) => {
      state.fillerAudioFileList = action.payload;
    },

    setMP3DataComponent: (
      state,
      action: PayloadAction<IMP3DataComponentState>
    ) => {
      state.mP3DataComponentState = action.payload;
    },

    setRedactionTagList: (state, action: PayloadAction<TreeNode[]>) => {
      state.redactionTagList = action.payload;
    },

    setEditModeProductionId: (state, action: PayloadAction<number>) => {
      state.editModeProductionId = action.payload;
    },

    setIsFieldsChanged: (
      state,
      action: PayloadAction<{isFieldsChanged: boolean}>
    ) => {
      state.isFieldsChanged = action.payload.isFieldsChanged || false;
    },
  },
});

export const {
  setProduction,
  clearProduction,
  setSecurityGroupId,
  clearSecurityGroupId,
  setProductionSetSetId,
  clearProductionSetId,
  setFillerAudioFileList,
  setMP3DataComponent,
  setRedactionTagList,
  setEditModeProductionId,
  setIsFieldsChanged,
} = productionSlice.actions;
export default productionSlice.reducer;
